import {
  HTTP_SELBRANDSPECIAL_FETCHING,
  HTTP_SELBRANDSPECIAL_SUCCESS,
  HTTP_SELBRANDSPECIAL_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_SELBRANDSPECIAL_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_SELBRANDSPECIAL_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_SELBRANDSPECIAL_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
